const SvgAutomation4 = (props) => (
  <>
    <path
      fill={props.p20}
      opacity={0.5}
      d="m47.536 223.997 48.451-48.451 48.451 48.45-48.45 48.452zM47.508 111.907 95.98 63.435l48.473 48.472L95.98 160.38z"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m96.2 224.05-56.02-55.91 55.95-55.95 55.66 55.67-55.59 56.19zM96.2 112.08 40.18 56.19 96.13.24l55.66 55.67-55.59 56.17zM96.132 224.13l55.664 55.664-55.954 55.954-55.663-55.664z"
    />
  </>
);

export default SvgAutomation4;
